import Image from "next/image";
import Link from "next/link";

export default function TimeSection() {
  return (
    <section id="time-section">
      <div className="flex justify-center w-full pt-10 pb-0 px-[18px] lg:px-18">
        <div className="flex flex-col items-center justify-center w-full max-w-[1200px] gap-14">
          <div className="flex flex-col lg:flex-row justify-between gap-5 items-center lg:items-start w-full">
            <h1 className="max-w-[650px] text-center lg:text-start text-wrap !font-semibold text-[#0D2A4C] !text-[32px] md:!text-[56px] md:leading-[58px] leading-[32px] tracking-tighter">
              Less Time Prospecting. More Time Closing.
            </h1>
            <div className="flex flex-col items-center lg:items-start gap-5 lg:gap-4">
              <p className="text-[#0D2A4C99] !font-medium text-[16px] max-w-[340px] text-wrap">
                ListKit delivers sales-ready leads so you can skip the busywork
                and close more deals.
              </p>
              <Link
                href="/pricing"
                className="bg-[#2A8DFF] text-center w-fit hover:bg-[#2A8DFF]/90 active:outline-1 active:outline-[#2A8DFF] active:bg-[#2A8DFF] rounded-[100px] py-[11px] px-[18px] md:py-[15px] md:px-[22px] cursor-pointer"
              >
                <p className="text-white text-sm md:text-[16px] font-semibold">
                  Get Started Now
                </p>
              </Link>
            </div>
          </div>
          <div className="flex flex-col gap-5 w-full">
            <div className="flex flex-col md:flex-row gap-5">
              <div className="p-6 md:basis-[48%] flex-shrink-0 bg-[#F8F9FA] rounded-[12px] flex flex-col items-start justify-between relative">
                <Image
                  src="/images/higher-reply-rates.webp"
                  alt="Higher Reply Rates"
                  width={1017}
                  height={398}
                  className="w-full hidden md:block px-4 pt-2"
                />
                <Image
                  src="/images/higher-reply-rates-mobile.webp"
                  alt="Higher Reply Rates"
                  width={622}
                  height={316}
                  className="w-full block md:hidden pb-8"
                />
                <div className="flex flex-col gap-1">
                  <p className="font-semibold text-2xl tracking-tight text-[#0D2A4C]">
                    Higher Reply Rates
                  </p>
                  <p className="font-medium text-[16px] text-[#0D2A4C99]">
                    Triple-verified leads reach real people and drive real
                    conversations.
                  </p>
                </div>
              </div>
              <div className="bg-[#F8F9FA] md:flex-grow rounded-[12px] flex flex-col items-start justify-between relative">
                <Image
                  src="/images/faster-outreach.webp"
                  alt="Faster Outreach"
                  width={1170}
                  height={484}
                  className="w-full hidden md:block"
                />
                <Image
                  src="/images/faster-outreach-mobile.webp"
                  alt="Faster Outreach"
                  width={691}
                  height={418}
                  className="w-full block md:hidden"
                />
                <div className="flex flex-col gap-1 p-6 -mt-4 md:-mt-0">
                  <p className="font-semibold text-2xl tracking-tight text-[#0D2A4C]">
                    Faster Outreach
                  </p>
                  <p className="font-medium text-[16px] text-[#0D2A4C99]">
                    ListKit handles the list-building and cleaning, so you can
                    focus on closing.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-5">
              <div className="md:p-6 pb-6 md:basis-[52%] flex-shrink-0 bg-[#F8F9FA] rounded-[12px] flex flex-col-reverse md:flex-col items-start justify-between relative">
                <div className="relative w-full">
                  <Image
                    src="/images/for-small-teams.webp"
                    alt="For Small Teams"
                    width={1092}
                    height={540}
                    className="w-full hidden md:block"
                  />
                  <Image
                    src="/images/for-small-teams-mobile.webp"
                    alt="For Small Teams"
                    width={498}
                    height={246}
                    className="w-full block md:hidden"
                  />
                  <div className="hidden md:block absolute bottom-0 left-0 w-full h-[80px] md:h-[100px] bg-gradient-to-t from-[#F8F9FA] to-transparent z-10 pointer-events-none" />
                </div>
                <div className="flex flex-col gap-1 md:-mt-4 z-10 p-6 md:p-0">
                  <p className="font-semibold text-2xl tracking-tight text-[#0D2A4C]">
                    Easier for Small Teams
                  </p>
                  <p className="font-medium text-[16px] text-[#0D2A4C99]">
                    The platform is simple, fast, and doesn’t require a learning
                    curve.
                  </p>
                </div>
              </div>
              <div className="bg-[#F8F9FA] md:flex-grow rounded-[12px] flex flex-col justify-between relative items-center">
                <div className="relative w-full">
                  <Image
                    src="/images/more-sales-conversations.webp"
                    alt="More Sales Conversations"
                    width={900}
                    height={584}
                    className="w-full z-0 px-5 hidden md:block"
                  />
                  <Image
                    src="/images/more-sales-conversations-mobile.webp"
                    alt="Higher Reply Rates"
                    width={327}
                    height={166}
                    className="w-full z-0 p-6 block md:hidden"
                  />
                  <div className="absolute top-0 left-0 w-full h-[80px] bg-gradient-to-b from-[#F8F9FA] to-transparent z-10 pointer-events-none" />
                  <div className="absolute bottom-0 left-0 w-full h-[95px] bg-gradient-to-t from-[#F8F9FA] to-transparent z-10 pointer-events-none" />
                </div>
                <div className="flex flex-col gap-1 z-10 md:p-6 px-6 pb-6 w-full items-start">
                  <p className="font-semibold text-2xl tracking-tight text-[#0D2A4C]">
                    More Sales Conversations
                  </p>
                  <p className="font-medium text-[16px] text-[#0D2A4C99]">
                    Every lead is triple-verified, so your emails land and get
                    responses.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
